export default "__VITE_ASSET__RiIzlwvb__"